import type {ScheduleItemDict} from '@domain/schedule'
import type {AssetSnapshot, AssetsHistory} from '@hconnect/common/types'
import moment, {Moment} from 'moment-timezone'

import type {AssetWithOperationMode} from '../types'

const getRelevantHistoryEntry = <
  T extends {updatedOn?: string; createdOn: string; id: string | number}
>(
  historyEntries: T[],
  date: Moment
): T | undefined => {
  const relevantHistoryAsc = historyEntries.filter((entry) => {
    const timeStamp = moment.utc(entry.updatedOn ?? entry.createdOn)
    return timeStamp.isBefore(date)
  })
  return relevantHistoryAsc.at(-1)
}

export const mapScheduleItemIdToAssetData = (
  scheduleItemDict: ScheduleItemDict,
  assetsHistory: AssetsHistory
): Record<string, AssetWithOperationMode> => {
  return Object.values(scheduleItemDict).reduce<Record<string, AssetWithOperationMode>>(
    (acc, scheduleItem) => {
      const assetHistory: AssetSnapshot[] | undefined = assetsHistory[scheduleItem.assetId]
      if (!assetHistory) {
        throw new Error(
          `BUG:No asset history found for asset ${scheduleItem.assetId} for the given scheduleItem ${scheduleItem.id}`
        )
      }
      const asset = getRelevantHistoryEntry(assetHistory, moment.utc(scheduleItem.end))
      if (!asset) {
        throw new Error(
          `BUG:No relevant asset snapshot found for the given scheduleItem ${scheduleItem.id} on asset ${scheduleItem.assetId}`
        )
      }
      const operationMode = asset.operationModes.find(
        (operationMode) => operationMode.id === scheduleItem.assetOperationModeId
      )
      if (!operationMode) {
        throw new Error(
          `BUG:No operation mode found for the given scheduleItem ${scheduleItem.id} on asset ${scheduleItem.assetId}`
        )
      }
      acc[scheduleItem.id] = {
        asset,
        operationMode
      }
      return acc
    },
    {}
  )
}
